export interface Shops {
    T4 : {
        pre: {id:string}
        post: {id:string,taxonomyID:string}
    }
    T3 : {
        pre : {id:string, taxonomyID:string}
    }
}


export const ShopsData : Shops = {
    T4 : {
        pre : { id : '545000a1-0c49-6a75-a385-ff1400f4265d'},
        post : {id:'546400a1-0c49-6a75-a385-ff1400f4265d',taxonomyID : '8f6800a1-0c49-6a75-a385-ff1400f4265d'}
    },

    T3 : {
        pre: {id:'e57200a1-0c49-6a75-a385-ff1400f4265d',taxonomyID : 'e95104a1-0c49-6a75-a385-ff1400f4265d'}
    }
}
